/* Header to go above each section of the website. */
const Header = () => {
    return (
        <div className="flex justify-center bg-slate-600">
            <div className="border-4 border-slate-600 rounded-sm px-6 mt-2 font-sans">
                {/*<div className="text-center text-2xl text-white font-semibold">Daniel Deneau</div>*/}
            </div>
        </div>
    )
}

export default Header